import { captcha } from "@store/actions/user";
import { useAppDispatch } from "@store/hooks";

// The surface the <Captcha> widget exposes to host forms — mirrors the subset
// of the old ReCAPTCHA ref we actually used (getValue/reset), so swapping the
// underlying widget (Google reCAPTCHA → self-hosted ALTCHA) needs no changes at
// the call sites.
export type CaptchaHandle = {
  getValue: () => string | null;
  reset: () => void;
};

let captchaRef: { current: CaptchaHandle | null } = { current: null };

export const useCaptcha = () => {
  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    // Widget not rendered (captcha disabled) → skip, treat as passed.
    if (!captchaRef.current) {
      return true;
    }

    const token = captchaRef.current.getValue() ?? "";
    captchaRef.current.reset();

    const response = await dispatch(captcha(token));

    return response.payload;
  };

  return { handleSubmit, captchaRef };
};
